/* 🤖 this file was generated by svg-to-ts */
export const matIconVideoCameraFront: {
  name: 'video-camera-front';
  data: string;
} = {
  name: 'video-camera-front',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zm-2-.79V18H4V6h12v3.69z"/><circle cx="10" cy="10" r="2"/><path d="M14 15.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 0 0-5.56 0A2.01 2.01 0 0 0 6 15.43V16h8v-.57z"/></svg>`
};
